import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// import loginBanner from '../../assets/images/login/login-banner.png';
// import sample from '../../assets/videos/background.mp4';

import { appCurrentBranding } from '../../../config/branding';
import { branding } from '../../../config/enum';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import CustomPhoneInput from '../../../shared-components/custom-input/CustomPhoneInput';
import RadioButton from '../../../shared-components/radio-button/RadioButton';
import { setLocalStorageItem } from '../../../shared-functions/LocalStorage';
import { emailValidation, phoneNumberValidation } from '../../../shared-functions/Validation';
import authApi from '../../../utils/api/auth';

/**
 * Login page function component
 */
function ForgetPassword() {
  const { t, i18n } = useTranslation('loginV2');
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState<{
    emailOrPhoneNumber: string;
    type: string | number;
    countryCode: string;
  }>({
    emailOrPhoneNumber: '',
    type: 'email',
    countryCode: appCurrentBranding === branding.VOLTIE ? '1' : '966',
  });
  const [disabled, setDisabled] = useState(false);
  const [submitOpen, setSubmitOpen] = useState(false);

  /**
   * Input field change function
   * @param name
   * @param changeValue
   */
  const handleCredentialChange = (name: string, changeValue: string | number) => {
    setCredentials({
      ...credentials,
      [name]: changeValue,
    });
  };

  /**
   * handle submit function
   */
  const submitFunction = () => {
    setSubmitOpen(true);
    if (
      credentials.countryCode !== '' &&
      (phoneNumberValidation(credentials.emailOrPhoneNumber) ||
        emailValidation(credentials.emailOrPhoneNumber))
    ) {
      setDisabled(true);
      const request = {
        emailOrPhoneNumber: credentials.emailOrPhoneNumber,
        countryCode: credentials.countryCode,
      };
      authApi
        .forgotPassword(request)
        .then(() => {
          setDisabled(false);
          setLocalStorageItem('passwordReset', credentials);
          navigate('../login/otp-verification');
        })
        .catch(() => {
          setDisabled(false);
          setLocalStorageItem('passwordReset', credentials);
          navigate('../login/otp-verification');
        });
    }
  };

  return (
    <div className="forgot-password-v2-wrap" dir={i18n.dir()}>
      <div className="forgot-password-v2-container">
        <div className="email-phone-toggle-wrap">
          <RadioButton
            name="type"
            value={credentials.type}
            list={[
              {
                label: `${t('email')}`,
                value: 'email',
              },
              {
                label: `${t('phoneNumber')}`,
                value: 'phone',
              },
            ]}
            onChangeValue={handleCredentialChange}
          />
          {credentials.type === 'email' ? (
            <CustomInput
              type="email"
              placeholder={t('enterEmail')}
              name="emailOrPhoneNumber"
              value={credentials.emailOrPhoneNumber}
              onChangeValue={handleCredentialChange}
              error={submitOpen && !emailValidation(credentials.emailOrPhoneNumber)}
              errorMessage={t('emailInvalid')}
            />
          ) : (
            <CustomPhoneInput
              type="number"
              placeholder={t('enterPhoneNumber')}
              name="emailOrPhoneNumber"
              value={credentials.emailOrPhoneNumber}
              value1={credentials.countryCode}
              onChangeValue={handleCredentialChange}
              error={submitOpen && !phoneNumberValidation(credentials.emailOrPhoneNumber)}
              errorMessage={t('phoneInvalid')}
            />
          )}
          <MyButton
            label={t('getOtp')}
            buttonType="submit"
            onClickFunc={submitFunction}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
